import { useAppSelector } from '../store';

export default () => useAppSelector(({ root: { authUser } }) => authUser);
